<template>
  <div>
    <div class="flex flex-wrap -m-1.5 xl:-m-2 2xl:-m-2.5">
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full lg:w-1/2">
        <div class="flex flex-wrap -m-2.5">
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('transport_facilities')"
              :count="seismic.all_transport_infrastructure || 0"
              :img="require('@/assets/img/icons/bridge-circle.svg')"
              class="bg-indigo-50 text-indigo-800 cursor-pointer h-full"
              @click="$router.push('/transport')"
            />
          </div>
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('sustainable_transport_structures')"
              :count="seismic.first_seismic || 0"
              :img="require('@/assets/img/icons/sustainable_buildings.svg')"
              class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
              @click="$router.push('/transport')"
            />
          </div>
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('not_sustainable_transport')"
              :count="seismic.second_seismic || 0"
              :img="require('@/assets/img/icons/not_sustainable_transport.svg')"
              class="bg-orange-50 text-amber-600 cursor-pointer h-full"
              @click="$router.push('/transport')"
            />
          </div>
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('not_sustainable_transport4_structures')"
              :count="seismic.third_seismic || 0"
              :img="
                require('@/assets/img/icons/not_sustainable_transport4_structures.svg')
              "
              class="bg-rose-50 text-rose-600 cursor-pointer h-full"
              @click="$router.push('/transport')"
            />
          </div>
        </div>
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full lg:w-1/2">
        <PieChart
          :series="series"
          :labels="labels"
          :loading="loading"
          class="h-full justify-center p-3 md:p-5 rounded-2xl bg-slate-100"
        />
      </div>
    </div>
    <pre>{{ data }}</pre>
  </div>
</template>

<script>
import StatisticCard from "./Card.vue";
import PieChart from "@/components/PieChart.vue";

export default {
  name: "TransportStatistic",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StatisticCard,
    PieChart,
  },
  computed: {
    series() {
      return [
        this.data.seismic?.first_seismic || 0,
        this.data.seismic?.second_seismic || 0,
        this.data.seismic?.third_seismic || 0,
      ];
    },
    seismic() {
      return this.data.seismic || {};
    },
  },
  data() {
    return {
      labels: [
        this.$t("sustainable_transport_structures"),
        this.$t("not_sustainable_transport"),
        this.$t("not_sustainable_transport4_structures"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
